/**
 * The password a player typed to get into a room, remembered for this tab.
 *
 * Kept beside playerId (which is also per-tab sessionStorage) and for the same
 * reason: a refresh past the reconnect grace makes you a stranger again, and
 * being asked to retype the password to get back into the game you were just
 * playing is indistinguishable from being kicked.
 *
 * It is no more secret than the room code already in the address bar, and it
 * never leaves the tab.
 */
const key = gameId => `robotrons:room-password:${gameId}`;

export function getRoomPassword(gameId) {
  try {
    return sessionStorage.getItem(key(gameId));
  } catch {
    // Private modes and blocked site data throw on access rather than
    // returning null. No stored password is a valid answer.
    return null;
  }
}

export function setRoomPassword(gameId, password) {
  try {
    sessionStorage.setItem(key(gameId), password);
  } catch {
    // Not being able to remember it costs one retype after a refresh.
  }
}

export function clearRoomPassword(gameId) {
  try {
    sessionStorage.removeItem(key(gameId));
  } catch {
    // Nothing stored means nothing to clear.
  }
}
